import Config from '../../globals/Config';
import {MyWindow} from '../../types/MyWindow';

declare const window: MyWindow;

const injectSmartPlayer = (): void => {
   const script = window.document.createElement('script');
   script.src = `${Config.smartPlayerCdnBaseUrl}/techsmith-smart-player.min.js`;
   script.type = 'text/javascript';
   script.async = true;
   window.document.body.appendChild(script);

   const link = window.document.createElement('link');
   link.href = `${Config.smartPlayerCdnBaseUrl}/techsmith-smart-player.min.css`;
   link.type = 'text/css';
   link.rel = 'stylesheet';
   window.document.body.appendChild(link);
};

export default {
   injectSmartPlayer
};
